module.exports = __webpack_public_path__ + "img/zone-complete.a4af5146.png";